<template>
<div>
  <!-- 刑侦专栏    -->
  <div
    v-for="(item,index) in columnListOne"
    :key="index"
    class="criminalInvestigation"
    :style="'background-image:url(' + item.imgurl + ');background-size: 1200px 80px;'"
    @click="goSpecialColumn(item)"
  ></div>
  <div class="specialbox">
    <div
    class="speciallist"
    v-for="(item,index) in columnListTwo"
    :key="index"
    @click="goSpecialColumn(item)"
    >
      <img :src="item.imgurl" />
    </div>
  </div>

  <div class="navtabNewimgbox">
    <div class="navtab">
      <ul class="tabshed">
        <li
          class="li-tab"
          v-for="(item,index) in tablist"
          :key="index"
          @click="toggleTabs(index)"
          :class="{activeclass:index==nowIndex}"
          @mouseenter="enterTab(index)"
        >
          <img :src="index==nowIndex?item.imgUrlActive:item.imgUrl" class="tabimg" />
          <div class="tabstext">{{item.name}}</div>
        </li>
      </ul>
    </div>
    <div class="navtabStaut"></div>
    <!-- 多次切换 -->
    <div class="resource-information-remedium">
      <div class="resourceInformationRemediumBoxbox" v-if="nowIndex==0">
        <div class="resourceIRLeftbox">
          <div class="resourceIRLeftTabboxhed">
            <ul class="resourceIRLeftTabbox">
              <li class="resourceIRLeftTablibox onele"
                v-for="(item,index) in tablistwoList"
                :key="index"
                @click="newTab(index,item)"
                :class="{resourceIRLeactiveww:index==nowIndexTg}"
              >{{item.name}}</li>
            </ul>
            <div
              class="navLibox"
              style="color:#1492ff;font-size:16px;cursor: pointer;"
              @click="pushnewslist"
            >更多 > ></div>
          </div>

          <!-- 最新资讯 -->
          <div class="resourceIRCount">
            <div class="resourceIRCountHede" v-if="newslistST[0]">
              <div class="resourceIRCountHedeLeft">
                <div>
                  <div class="resourceIRCountHedeMonth">{{newslistST[0].publishTime.slice(-2)}}</div>
                  <div class="resourceIRCountHedeYear">{{newslistST[0].publishTime.slice(0,7)}}</div>
                </div>
              </div>
              <div class="resourceIRCountHedeRight">
                <div
                  class="resourceIRCountHedeLabel"
                  @click="newsHandleClick(newslistST[0],index)"
                >{{newslistST[0].title}}</div>
                <div class="resourceIRCountHedeBottom">
                  <span>来源：{{newslistST[0].source}}</span>
                  <span>供稿单位：{{newslistST[0].deptName}}</span>
                </div>
              </div>
            </div>
            <!-- 渐变线条 -->
            <div style="border:1px dashed #e9e9e9;"></div>

            <div style="padding-top:15px">
              <div
                class="tablelitwo"
                v-for="(item,index) in newslistST"
                :key="index"
                @click="newsHandleClick(item,index)"
              >
                <div class="bordeRou" v-if="index>0"></div>
                <div class="dillclassName" v-if="index>0">{{item.title}}</div>
                <div v-if="index>0" style="padding-right:5px">({{item.readCount}})</div>
                <div class="apply" v-if="index>0">{{item.publishTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="resourceIRRight">
          <div
            class="InstructorLibraryrightlis"
            style="height:100px;line-height: 100px;margin-bottom: 0"
          >
            <img src="@/assets/newIndex/u30723 (1).png" />
            <div class="Nmaes">今日资讯</div>
            <div class="sums">{{ NewMesTongJi.item1}}</div>
            <div class="units">条</div>
          </div>

          <div
            class="InstructorLibraryrightlis"
            style="height:100px;line-height: 100px;margin-bottom: 0"
          >
            <img src="@/assets/newIndex/u30727 (1).png" />
            <div class="Nmaes">今日资源</div>
            <div class="sums">{{NewMesTongJi.item2}}</div>
            <div class="units">条</div>
          </div>
          <div
            class="InstructorLibraryrightlis"
            style="height:100px;line-height: 100px;margin-bottom: 0"
          >
            <img src="@/assets/newIndex/u30732.png" />
            <div class="Nmaes">今日课程</div>
            <div class="sums">{{NewMesTongJi.item3}}</div>
            <div class="units">条</div>
          </div>
          <div
            class="InstructorLibraryrightlis"
            style="height:100px;line-height: 100px;margin-bottom: 0"
          >
            <img src="@/assets/newIndex/u30737.png" />
            <div class="Nmaes">今日考试</div>
            <div class="sums">{{NewMesTongJi.item4}}</div>
            <div class="units">条</div>
          </div>
          <div
            class="InstructorLibraryrightlis"
            style="height:100px;line-height: 100px;margin-bottom: 0;border-bottom:0"
          >
            <img src="@/assets/newIndex/u30742.png" />
            <div class="Nmaes">今日培训</div>
            <div class="sums">{{NewMesTongJi.item5}}</div>
            <div class="units">条</div>
          </div>
        </div>
      </div>
      <div class="resourceInformationRemediumBox" v-if="nowIndex==1">
        <div class="resourceIRLeft">
          <ul class="resourceIRLeftTab">
            <li
              class="resourceIRLeftTabli"
              style="width:174px;margin-bottom: 5px;"
              v-for="(item,index) in remediumListTab"
              :key="index"
              @click="remeDnewTab(index,item)"
              :class="{resourceIRLeactive:index==nowIndexremeD}"
            >
              <div class="tabstext">{{item.name}}</div>
            </li>
            <li
              class="navLi"
              style="color:#1492ff;font-size:16px;cursor: pointer;"
              @click="pushTrainlist"
            >更多 > ></li>
          </ul>
          <!-- 调训管理 -->
          <div class="resourceIRCount">
            <div class="resourceIRCountHede" v-if="remediumList[0]">
              <div class="resourceIRCountHedeLeft">
                <div>
                  <div class="resourceIRCountHedeMonth">{{remediumList[0].starTime.slice(-2)}}</div>
                  <div class="resourceIRCountHedeYear">{{remediumList[0].starTime.slice(0,7)}}</div>
                </div>
              </div>
              <div class="resourceIRCountHedeRight">
                <div
                  class="resourceIRCountHedeLabel"
                  @click="trainclass(remediumList[0].id)"
                >{{remediumList[0].title}}</div>
                <div class="resourceIRCountHedeBottom">
                  <!-- <span>发布日期：2021-06-09 10:05</span> -->
                  <span>来源：{{remediumList[0].deptName}}</span>
                </div>
              </div>
            </div>
            <!-- 渐变线条 -->
            <div style="border:1px dashed #e9e9e9;"></div>
            <div style="padding-top:15px">
              <div class="tablelitwo" v-for="(item,index) in remediumList" :key="index">
                <div class="bordeRou" v-if="index>0"></div>
                <div
                  class="dillclassName"
                  @click="trainclass(item.id)"
                  v-if="index>0"
                >{{item.title}}</div>
                <div
                  style="width:200px;color:#666;padding:0 5px"
                  v-if="index>0"
                >{{item.jzDicName}}</div>
                <div class="apply" v-if="index>0">{{item.starTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="resourceIRRight">
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30718.png" />
            <div class="Nmaes">进行中</div>
            <div class="sums">{{TrainTongJi.item1}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30723 (1).png" />
            <div class="Nmaes">未开始</div>
            <div class="sums">{{TrainTongJi.item2}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30727 (1).png" />
            <div class="Nmaes">审核中</div>
            <div class="sums">{{TrainTongJi.item3}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30732.png" />
            <div class="Nmaes">月度调训</div>
            <div class="sums">{{TrainTongJi.item4}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30737.png" />
            <div class="Nmaes">季度调训</div>
            <div class="sums">{{TrainTongJi.item5}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30742.png" />
            <div class="Nmaes">年度调训</div>
            <div class="sums">{{TrainTongJi.item6}}</div>
          </div>
        </div>
      </div>
      <div class="resourceInformationRemediumBox" v-if="nowIndex==2">
        <div class="resourceIRLeft">
          <ul class="resourceIRLeftTab">
            <li
              class="resourceIRLeftTabli"
              style="width:140px"
              v-for="(item,index) in learningResourceTab"
              :key="index"
              @click="ResourceTab(index,item)"
              :class="{resourceIRLeactive:index==nowIndexResource}"
              v-if="index<5"
            >
              <div class="tabstext">{{item.name}}</div>
            </li>
            <li
              class="navLi"
              style="color:#1492ff;font-size:16px;cursor: pointer;"
              @click="pushresourceslist"
            >更多 > ></li>
          </ul>

          <div class="resourceIRCount" style="margin:0;padding:10px">
            <!-- 渐变线条 -->
            <div style="border:1px dashed #e9e9e9;"></div>
            <div class="studyRoucet">
              <div
                class="studyRoucetli"
                style="paddgin:10px 0 10px 10px"
                v-for="(item,index) in resourcesList"
                :key="index"
              >
                <img
                  :src="item.imgUrl"
                  style=" margin-left:10px;cursor: pointer;"
                  @click="videolearn(index,item)"
                  alt
                />
                <div class="studyRoucetliRight">
                  <div
                    class="studyRoucetliRightTitle"
                    @click="videolearn(index,item)"
                  >{{item.name}}</div>
                  <div class="studyRoucetliRightIcon">
                    <div class="rigIcon-img">
                      <img src="@/assets/icon/观看.svg" style alt />
                      <span style="margin-left:5px">{{item.visitNum}}</span>
                    </div>
                    <div class="rigIcon-img" style="margin-left:16px;">
                      <img src="@/assets/icon/评论.svg" alt />
                      <span style="margin-left:5px">{{item.talkCount}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="resourceIRRight">
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30718.png" />
            <div class="Nmaes">视频资源</div>
            <div class="sums">{{DocumentTongJi.item1}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30723 (1).png" />
            <div class="Nmaes">文档资源</div>
            <div class="sums">{{DocumentTongJi.item2}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30727 (1).png" />
            <div class="Nmaes">图片资源</div>
            <div class="sums">{{DocumentTongJi.item3}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30732.png" />
            <div class="Nmaes">音频资源</div>
            <div class="sums">{{DocumentTongJi.item4}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30737.png" />
            <div class="Nmaes">PDF资源</div>
            <div class="sums">{{DocumentTongJi.item5}}</div>
          </div>
          <div class="InstructorLibraryrightlis">
            <img src="@/assets/newIndex/u30742.png" />
            <div class="Nmaes">PPT资源</div>
            <div class="sums">{{DocumentTongJi.item6}}</div>
          </div>
        </div>
      </div>
      <div class="resourceInformationRemediumBox" v-if="nowIndex==3">
        <div class="resourceIRLeft" style="width:1200px">
          <ul class="resourceIRLeftTab">
            <li
              class="resourceIRLeftTabli"
              style="width:210px"
              v-for="(item,index) in specialTabList"
              :key="index"
              @click="specialTab(index,item)"
              :class="{resourceIRLeactive:index==nowIndexspecial}"
            >
              <div class="tabstext">{{item.name}}</div>
            </li>
            <li
              class="navLi"
              style="color:#1492ff;font-size:16px;cursor: pointer;"
              @click="moocZhuanti()"
            >更多 > ></li>
          </ul>

          <div class="resourceIRCount" style="padding:0;margin:0">
            <!-- 渐变线条 -->
            <div style="border:1px dashed #e9e9e9;"></div>
            <div class="trainingvideo">
              <div class="trainingvideright">
                <div
                  class="trainingimgli"
                  v-for="(item,index) in courseData"
                  :key="index"
                  v-if="index<5"
                  @click="videolearn(index,item)"
                  style="cursor: pointer;"
                >
                  <img :src="item.imgUrl" />
                  <div style="margin-left:5px;margin-right:5px">
                    <div class="traingimgtext onele">{{item.name}}</div>
                    <div>
                      <p style="font-size:12px;padding: 5px 0;color: gray;">{{item.deptName}}</p>
                    </div>
                    <div class="traingimgnametxtlil">
                      <div class="traintext" v-if="item.jzDicName">{{item.jzDicName}}</div>
                      <div class="traingimgflex">
                        <div class="trainicon" style="margin-right:10px">
                          <img src="@/assets/resource/u231.svg" alt />
                          {{item.visitNum}}
                        </div>
                        <div class="trainicon" style="margin-right:10px">
                          <img src="@/assets/videoimg/studycommentPlin.svg" alt />
                          <span>{{item.talkCount}}</span>
                        </div>
                        <div class="trainicon">
                          <img src="@/assets/videoimg/give.svg" style="width:16px;height:16px" />
                          <span>{{item.assistCount}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <nodata v-if="courseData.length==0" style="margin: 0 auto;"></nodata>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  GetSecondList,
  HomeTrainTongJi,
  HomeDocumentTongJi,
  Gethometextlist,
  getPmiDic,
  GetTrainList,
  GetMoocSpecialList,
  getHomeCourseList,
  HomeNewMesTongJi,
  getColumnList,
} from '@/api/clientshome/index.js';
import {
  getDocumentByClass,
  GetDocSecondList,
  DocumentRead,
} from '@/api/resources/index.js';
export default {
  data(){
    return {
      tablist: [
        {
          name: '最新资讯',
          id: 0,
          imgUrl: require('@/assets/newIndex/u30917.png'),
          imgUrlActive: require('@/assets/newIndex/u30917Active.png'),
        },
        {
          name: '调训管理',
          id: 1,
          imgUrl: require('@/assets/newIndex/u30876.png'),
          imgUrlActive: require('@/assets/newIndex/u30876Active.png'),
        },
        {
          name: '学习资源',
          id: 2,
          imgUrl: require('@/assets/newIndex/u30875.png'),
          imgUrlActive: require('@/assets/newIndex/u30875Active.png'),
        },
        {
          name: '课程专题',
          id: 3,
          imgUrl: require('@/assets/newIndex/u30912.png'),
          imgUrlActive: require('@/assets/newIndex/u30912Active.png'),
        },
      ],
      nowIndex: 0,
      nowIndexTgCareId: 0,
      nowIndexremeDclassLevel: 0, //调训的类别Id
      nowIndexResourceClassDicId: 0, //资源的类别Id
      specialId: 1,
      nowIndexTg: 0, //新闻的ID
      nowIndexremeD: 0, //调训的ID
      nowIndexResource: 0, //资源的id
      nowIndexspecial: 0, //课程的id
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      columnListOne: [],
      columnListTwo: [],
      newslistST: [], //最新消息的列表
      remediumList: [],
      resourcesList: [],
      learningResourceTab: [],
      specialTabList: [],
      courseData: [],
      tablistwoList: [],
      remediumListTab: [],
      DocumentTongJi: {},
      NewMesTongJi: {},
    }
  },
  created(){
    this.getTongJI();
    this.getGetSecondList(62, this.tablistwoList);
    this.getColumnList();
  },
  methods:{
    getColumnList() {
      getColumnList().then((res) => {
        let list = res.result;
        for (let i = 0; i < list.length; i++) {
          if (list[i].type == 1) {
            this.columnListOne.push(list[i]);
          } else if (list[i].type == 2) {
            this.columnListTwo.push(list[i]);
          }
        }
        console.log(this.columnListOne,this.columnListTwo);
        
      });
    },
    // tab切换
    toggleTabs(index) {
      this.nowIndex = index;
    },
    enterTab(index) {
      this.nowIndex = index;
      if(index==0){
        if(this.tablistwoList.length==0){
          this.getGetSecondList(62, this.tablistwoList);
        }
      }else if(index==1){
        if(this.remediumListTab.length==0){
          HomeTrainTongJi().then((res) => {
            this.TrainTongJi = res.result;
          });
          this.getPmiDictionary(9, this.remediumListTab);
        }
      }else if(index==2){
        if(this.learningResourceTab.length==0){ 
          GetDocSecondList().then((res) => {
            if(res.result.length>0){
              this.learningResourceTab = res.result;
              this.nowIndexResourceClassDicId = res.result[0].id;
              this.Getresources();
            }
            HomeDocumentTongJi().then((res) => {
              this.DocumentTongJi = res.result;
            });
          });
        }
      }else if(index==3){
        if(this.specialTabList.length==0){
          this.getMoocSpecialList();
        }
      }
    },
    //根据字典条件查询并赋值
    getGetSecondList(index, arr) {
      this.listQuery.isshow = true;
      GetSecondList(this.listQuery).then((response) => {
        response.result.forEach((e, i) => {
          arr.push({ name: e.name.substring(0, 4), id: e.id });
        });
        this.nowIndexTgCareId = response.result[0].id;
        this.Gethometextlist();
      });
    },
    // 获取文字新闻列表
    Gethometextlist() {
      let para = {
        top: 9,
        cateId: this.nowIndexTgCareId,
      };
      this.newslistST=[]
      Gethometextlist(para).then((res) => {
        this.newslistST = res.result;
      });
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      getPmiDic(this.listQuery).then((response) => {
        response.result.forEach((e, i) => {
          arr.push({ name: e.name, id: e.id });
          if (index == 9 && i == 0) {
            this.nowIndexremeDclassLevel = arr[0].id;
            this.GetTrainList();
          } else if (index == 51 && i == 0) {
            this.nowIndexResourceClassDicId = arr[0].id;
            this.Getresources();
          }
        });
      })
    },
    // 获取调训的数据
    GetTrainList(){
      this.remediumList=[]
      GetTrainList({ top: 9, classLevel: this.nowIndexremeDclassLevel }).then((res) => {
        this.remediumList = res.result;
        res.result.forEach((element, index) => {
          let star = element.starTime.slice(0, 10);
          this.remediumList[index].starTime = star;
          let end = element.endtime.slice(0, 10);
          this.remediumList[index].endtime = end;
        });
      });
    },
    // 获取资源列表
    Getresources(){
      let data = {
        Page: 1,
        Limit: 12,
        State: 1,
        ClassDicId: this.nowIndexResourceClassDicId,
      };
      this.resourcesList=[]
      getDocumentByClass(data).then((res)=>{
        this.resourcesList = res.result;
      });
    },
    getMoocSpecialList() {
      GetMoocSpecialList({ top: 5 }).then((res) => {
        this.specialTabList = res.result;
        this.specialId = res.result[0].id;
        this.getHomeCourseList();
      });
    },
    getHomeCourseList() {
      this.courseData=[]
      getHomeCourseList({ specialId: this.specialId, isshow: true }).then((res) => {
        this.courseData = res.result;
      });
    },
    // 新闻切换
    newTab(index, item) {
      this.nowIndexTg = index;
      this.nowIndexTgCareId = item.id;
      this.Gethometextlist();
    },
    // 点击更多进入新闻列表页面
    pushnewslist(){
      this.$router.push({
        path: '/home/newsList',
        query: {
          CateId: this.nowIndexTgCareId,
        },
      });
    },
    // 点击跳转新闻详细页面
    newsHandleClick(item, index) {
      this.$router.push({
        path: '/home/newsgetone',
        query: {
          CateId: this.nowIndexTgCareId,
          id: item.id,
        },
      });
    },
    getTongJI() {
      HomeNewMesTongJi().then((res) => {
        this.NewMesTongJi = res.result;
      });
    },
    // 调训
    remeDnewTab(index, item) {
      this.nowIndexremeD = index;
      this.nowIndexremeDclassLevel = item.id;
      this.GetTrainList();
    },
    //更多调训
    pushTrainlist() {
      this.$router.push({
        path: '/train',
      });
    },
    // 调训跳转详细页面
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    ResourceTab(index, item) {
      this.nowIndexResource = index;
      this.nowIndexResourceClassDicId = item.id;
      this.Getresources();
    },
    //更多
    pushresourceslist() {
      this.$router.push({
        path: '/sourceslist',
      });
    },
    //
    videolearn(index, item) {
      DocumentRead(item.id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: item.id,
        },
      });
    },
    //更多课程
    moocZhuanti() {
      this.$router.push({
        path: '/mooc/disstationList',
      });
    },
    // 课程
    specialTab(index, item) {
      this.nowIndexspecial = index;
      this.specialId = item.id;
      this.getHomeCourseList();
    },
    //点击跳转到专栏页面
    goSpecialColumn(item) {
      if(item.weburl) {
        window.open(item.weburl);
      }else if(item.isurl) {
        this.$router.push({
          path: '/home/specialColumn',
          query: {
            id: item.id,
            type: item.type,
          },
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
// 刑侦教育专栏
.criminalInvestigation {
  text-align: center;
  font-size: 28px;
  color: #fff;
  font-weight: bold;
  height: 80px;
  width: 1200px;
  line-height: 80px;
  background-size: 100%;
  margin: 0 auto;
  margin-top: 10px;
  &:hover {
    cursor: pointer;
  }
}
.criminalInvestigation:nth-child(1) {
  margin-bottom: 10px;
}

.specialbox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .speciallist {
    width: 295px;
    height: 90px;
    margin-top: 10px;
    box-sizing: border-box;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
}

// 警种调训+学习资源+课程专题
.navtabNewimgbox {
  // height: 620px;
  font-family: '微软雅黑', sans-serif;
  width: 1200px;
  margin: 0 auto;
  // margin-top: 10px;
  .navtab {
    padding: 15px 0;
    width: 1200px;
    margin: 0 auto;
    .tabshed {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      color: #333;
      line-height: 24px;
      .li-tab {
        cursor: pointer;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        letter-spacing: 1px;
        width: 280px;
        height: 70px;
        line-height: 70px;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 1);
        border-radius: 5px;
        -moz-box-shadow: -2px -2px 6px rgba(215, 215, 215, 0.92156862745098);
        -webkit-box-shadow: -2px -2px 6px rgb(215 215 215 / 92%);
        box-shadow: -2px -2px 6px rgb(215 215 215 / 92%);
      }
      .tabimg {
        height: 30px;
        width: 34px;
      }
      .tabstext {
        margin-left: 10px;
      }
    }
    .activeclass {
      color: #fff;
      background-color: #1492ff;
    }
  }
  .navtabStaut {
    height: 8px;
    background-color: #1492ff;
    width: 1200px;
    margin: 0 auto;
  }

  .resource-information-remedium {
    font-family: '微软雅黑', sans-serif;
    width: 1200px;
    margin: 0 auto;
    margin-top: 10px;
    .resourceInformationRemediumBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .resourceIRLeft {
        width: 850px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        .resourceIRLeftTab {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          color: #7f7f7f;
          line-height: 28px;
          min-height: 28px;
          padding: 20px 10px 30px 20px;
          .resourceIRLeftTabli {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            letter-spacing: 1px;
            box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
            border-radius: 5px;
            border-right: 1px solid rgb(215 215 215 / 28%);
            border-bottom: 1px solid rgb(215 215 215 / 28%);

            &:hover {
              cursor: pointer;
              background-color: #1492ff;
              color: #fff;
            }
          }
          .navLi:hover {
            border-bottom: solid 1px #1492ff;
          }
          // .tabstext {
          //   margin-left: 10px;
          // }
        }

        .resourceIRCount {
          border-radius: 5px;
          margin-top: 20px;
          padding: 0 10px 0 30px;
          .resourceIRCountHede {
            display: flex;
            padding-bottom: 20px;
            .resourceIRCountHedeLeft {
              height: 80px;
              width: 80px;
              // border: 1px solid #ffa200;
              color: #fff;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #ffa200;
              .resourceIRCountHedeMonth {
                font-size: 28px;
                font-weight: bold;
              }
              .resourceIRCountHedeYear {
                font-size: 14px;
                margin-top: 5px;
              }
            }
            .resourceIRCountHedeRight {
              padding-left: 30px;
              .resourceIRCountHedeLabel {
                font-size: 18px;
                color: #000;
              }
              .resourceIRCountHedeLabel:hover {
                color: #1492ff;
                cursor: pointer;
              }
              .resourceIRCountHedeBottom {
                font-size: 14px;
                color: #666;
                display: flex;
                margin-top: 10px;
              }
            }
          }
          .tablelitwo {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 14px;

            .bordeRou {
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background: #1492ff;
            }
            .dillclassName {
              // width: 700px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 10px;
              font-size: 16px;
              margin-left: 10px;
              flex: 1;
              color: #333;
              &:hover {
                color: #1492ff;
                text-decoration: underline;
                cursor: pointer;
              }
            }

            .apply {
              color: #666;
            }
          }
        }
      }
      .resourceIRRight {
        width: 270px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        padding: 20px 15px 0 15px;
        .InstructorLibraryrightlis {
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          font-size: 18px;
          height: 60px;
          line-height: 60px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            height: 30px;
            width: 30px;
          }

          .Nmaes {
            color: #000;
            margin-left: 15px;
            // width: 135px;
            flex: 1;
          }
          .sums {
            font-weight: bold;
            color: #1492ff;
          }
        }
        .InstructorLibraryrightlis:nth-child(6) {
          border-bottom: 0;
        }
      }
    }

    .resourceInformationRemediumBoxbox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .resourceIRLeftbox {
        width: 850px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        .resourceIRLeftTabboxhed {
          display: flex;
          padding: 20px 10px 30px 20px;
          color: #7f7f7f;
          .resourceIRLeftTabbox {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
            justify-content: start;
            flex: 1;
            .resourceIRLeftTablibox {
              margin: 5px 10px;
              width: 100px;
              height: 28px;

              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;

              box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
              box-sizing: border-box;
              border-right: 1px solid rgb(215 215 215 / 28%);
              border-bottom: 1px solid rgb(215 215 215 / 28%);
              border-radius: 5px;
              &:hover {
                // color: #1492ff;
                cursor: pointer;
                // font-weight: bold;
                background-color: #1492ff;
                color: #fff;
              }
            }
          }
          .navLibox {
            width: 90px;
            font-size: 16px;
            box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .navLibox:hover {
            text-decoration: underline;
          }
        }

        .resourceIRCount {
          border-radius: 5px;
          margin-top: 20px;
          padding: 0 10px 0 30px;
          .resourceIRCountHede {
            display: flex;
            padding-bottom: 20px;
            .resourceIRCountHedeLeft {
              height: 80px;
              width: 80px;
              // border: 1px solid #ffa200;
              color: #fff;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #ffa200;
              .resourceIRCountHedeMonth {
                font-size: 28px;
                font-weight: bold;
              }
              .resourceIRCountHedeYear {
                font-size: 14px;
                margin-top: 5px;
              }
            }
            .resourceIRCountHedeRight {
              padding-left: 30px;
              .resourceIRCountHedeLabel {
                font-size: 18px;
                color: #000;
              }
              .resourceIRCountHedeLabel:hover {
                color: #1492ff;
                cursor: pointer;
              }
              .resourceIRCountHedeBottom {
                font-size: 14px;
                color: #666;
                display: flex;
                margin-top: 10px;
              }
            }
          }
          .tablelitwo {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 14px;

            .bordeRou {
              height: 5px;
              width: 5px;
              border-radius: 50%;
              background: #1492ff;
            }
            .dillclassName {
              // width: 700px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-right: 10px;
              font-size: 16px;
              margin-left: 10px;
              flex: 1;
              color: #333;
              &:hover {
                color: #1492ff;
                text-decoration: underline;
                cursor: pointer;
              }
            }

            .apply {
              color: #666;
            }
          }
        }
      }
      .resourceIRRight {
        width: 270px;
        border: 1px solid #f2f2f2;
        border-radius: 5px;
        padding: 20px 15px 0 15px;
        .InstructorLibraryrightlis {
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          font-size: 18px;
          height: 60px;
          line-height: 60px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            height: 30px;
            width: 30px;
          }

          .Nmaes {
            color: #000;
            margin-left: 15px;
            // width: 135px;
            flex: 1;
          }
          .sums {
            font-weight: bold;
            color: #1492ff;
          }
        }
        .InstructorLibraryrightlis:nth-child(6) {
          border-bottom: 0;
        }
      }
    }
  }
}
.resourceIRLeactive {
  cursor: pointer;
  background-color: #1492ff;
  color: #fff;
}
.resourceIRLeactiveww {
  cursor: pointer;
  background-color: #1492ff;
  color: #fff;
  // font-weight: bold;
}

// 学习资源
.studyRoucet {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 20px;
  .studyRoucetli {
    width: 255px;
    display: flex;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
    padding: 10px 0;
    margin-bottom: 20px;
    img {
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
    .studyRoucetliRight {
      padding-left: 20px;
      .studyRoucetliRightTitle {
        width: 160px;
        font-size: 16px;
        color: #000;
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:hover {
          color: #1492ff;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .studyRoucetliRightIcon {
        display: flex;
        margin-top: 15px;
        .rigIcon-img {
          font-size: 14px;
          color: #666;
          display: flex;
          align-items: center;

          img {
            height: 16px;
            width: 16px;
          }
        }
      }
    }
  }
}

// 专题
.trainingvideo {
  padding-top: 20px;
  display: flex;
  width: 1200px;
  min-height: 250px;
  .trainingvideright {
    flex: 1;
    display: flex;
    flex-wrap: wrap;

    .trainingimgli {
      width: 224px;
      // height: 230px;
      margin: 0 0 20px 14px;
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(242, 242, 242, 1);
      border-radius: 5px;
      padding: 10px 0;
      &:hover {
        box-shadow: 1px 1px 5px rgba(156, 154, 154, 0.996);
        transform: scale(1.02);
      }
      img {
        width: 222px;
        height: 136px;
        border-radius: 5px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      .traingimgtext {
        font-size: 16px;
        margin-top: 6px;
      }
      .traingimgnametxtlil {
        font-size: 14px;
        display: flex;
        margin-top: 6px;
        .traintext {
          padding: 3px 5px;
          color: #fff;
          background-color: #4876c4;
          border-radius: 4px;
          font-size: 13px;
          margin-right: 8px;
        }
        .trainicon {
          display: flex;
          align-items: center;
          color: #666;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}

.traingimgflex {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
</style>